/** Maximum rows requested from the modelAPI data-source preview endpoint. */
export const DATA_IMPORT_PREVIEW_ROW_LIMIT = 500;

/** User-facing copy when the API reports additional rows beyond the preview. */
export function getDataImportPreviewNoticeText(
  previewRowCount: number,
  hasMore: boolean,
  totalRows?: number | null,
): string | null {
  if (!hasMore || previewRowCount <= 0) {
    return null;
  }

  const shown = previewRowCount.toLocaleString();
  if (totalRows != null) {
    return `Showing the first ${shown} of ${totalRows.toLocaleString()} rows`;
  }
  return `Showing the first ${shown} rows only — not all rows are shown`;
}
